import { Outlet } from 'react-router'

export default function WorkspaceLayout() {
  return <Outlet />
}
